module.exports = __webpack_public_path__ + "static/media/no-offers-car.496d175f.png";